export default __webpack_public_path__ + "static/media/upload_26.034a36aa.svg";